export default class GroupedValidationItem {
    constructor(dto) {
        this.contentTypeID = 0;
        this.objectID = 0;
        this.contentTypeName = '';
        this.selectedFlow = '';
        this.availableFlows = [];
        this.availableFields = [];
        this.actionFields = [];
        this.comment = '';

        if (dto) {
            this.selectedFlow = dto.SelectedFlow;
            this.availableFlows = dto.Flows;
            this.contentTypeID = dto.ContentTypeID;
            this.contentTypeName = dto.ContentTypeName || '';
            this.objectID = dto.ObjectID || 0;
        }
    }
}
